module.exports = __webpack_public_path__ + "static/media/attendance-report-present.0773e9e3.svg";